// shirts-hierarchy.js
// Shirts filter hierarchy — Categories → Leagues → Teams → Product Types
//
// CATEGORIES currently supported:
//   1. Football Jerseys  — traditional league/team/type structure
//   2. Gym Shirts        — Type + Brand + Season, Men|Women tabs
//   3. Casual Shirts     — Brand + Season-conditional Types, Men|Women tabs
//   4. Formula 1         — 15 brand-as-team collections, Kids tabs
//   5. Caps              — 2 brand collections, unisex (no gender tabs)

window.ShirtsHierarchy = {

  // ============ GLOBAL PRODUCT TYPES ============
  // Tag-based filters used on Football team pages.
  // F1 overrides these with its own productTypes list.
  productTypes: [
    // Season 26/27 — featured kit, highlighted first.
    // `collectionHandle` tells footer chips to link to the dedicated collection
    // (/collections/new-season-26-27) instead of the default parent+tag URL.
    // On team pages, clicking this pill still filters by the Season 2026/27 tag.
    { tag: "Season 2026/27", title: "Season 26/27", collectionHandle: "new-season-26-27" },
    { tag: "Home",         title: "Home" },
    { tag: "Away",         title: "Away" },
    { tag: "Retro",        title: "Retro" },
    { tag: "LONG SLEEVE",  title: "LONG SLEEVE" },
    { tag: "Short Sleeve", title: "Short Sleeve" },
    { tag: "Shorts",       title: "Shorts" },
    { tag: "Track Suit",   title: "Track Suit" },
    { tag: "Jacket",       title: "Jacket" },
    { tag: "Scarf",        title: "Scarf" },
    { tag: "Ball",         title: "Ball" }
  ],

  // ============ SUPPORTED GENDERS PER CATEGORY ============
  // Used on gender landing pages (/collections/women, /men, /kids) to reorder
  // the categories row so gender-relevant categories appear first.
  // NOTE: this is separate from `genderTabs` (per-category gender switching);
  // it's ONLY consulted on top-level landings.
  //
  // Add this key to any new category to signal which genders it supports.
  // Categories WITHOUT this field are assumed to support ['men', 'kids'].

  // ============ CATEGORIES (top-level) ============
  categories: {

    // ==================== FOOTBALL JERSEYS ====================
    "football-jerseys": {
      title: "Football Jerseys",
      supportedGenders: ['men', 'kids'],

      leagues: {

        "premier-league": {
          title: "Premier League",
          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
          teams: {
            "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
            "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
            "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
            "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
            "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
            "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
            "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
          }
        },

        "la-liga": {
          title: "La Liga",
          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
          teams: {
            "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
            "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
            "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
          }
        },

        "serie-a": {
          title: "Serie A",
          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
          teams: {
            "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
            "inter-milan": { title: "Inter Milan", logo: "" },
            "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
            "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
          }
        },

        "bundesliga": {
          title: "Bundesliga",
          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
          teams: {
            "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
            "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
          }
        },

        "international-kits": {
          title: "International Kits",
          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
          handle: ["international-kits", "national-team-jerseys-home-away"],
          teams: {
            "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
            "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil" },
            "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France" },
            "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany" },
            "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal" }
          }
        }

      }
    },

    // ==================== GYM SHIRTS ====================
    "gym-shirts": {
      title: "Gym Shirts",
      handle: "sport-fit",
      supportedGenders: ['men', 'women'],

      genderTabs: {
        men:   { label: "Men",   tag: "Men"   },
        women: { label: "Women", tag: "Women" }
      },
      defaultGender: "men",

      rowLabel: "TYPE",
      teamRowLabel: "BRAND",

      leagues: {
        "jackets": { title: "Jackets & Coats",         logo: null, genderHandles: { men: "men-jackets", women: "women-jackets" } },
        "hoodies": { title: "Hoodies & Sweatshirts",   logo: null, genderHandles: { men: "men-hoodies", women: "women-hoodies" } },
        "tops":    { title: "Tops & T-Shirts",         logo: null, genderHandles: { men: "men-tops",    women: "women-tops"    } },
        "pants":   { title: "Trousers & Leggings",     logo: null, genderHandles: { men: "men-pants",   women: "women-pants"   } },
        "shorts":  { title: "Shorts",                  logo: null, genderHandles: { men: "men-shorts",  women: "women-shorts"  } },
        "skirts":  { title: "Skirts & Skorts",         logo: null, genderHandles: { men: "men-skirts",  women: "women-skirts"  } },
        "polos":   { title: "Polo Shirts",             logo: null, genderHandles: { men: "men-polos",   women: "women-polos"   } }
      },

      brands: [
        { title: "Nike",   tag: "Nike",   logo: null },
        { title: "Adidas", tag: "Adidas", logo: null }
      ],

      seasons: [
        { title: "Summer", tag: "Summer", emoji: "🌞" },
        { title: "Winter", tag: "Winter", emoji: "❄️" }
      ],

      labelClicks: {
        teams: {
          pattern: "brand-collection",
          buttonTextFormat: "Shop {name}"
        }
      }
    },

    // ==================== CASUAL SHIRTS ====================
    "casual-shirts": {
      title: "Casual Shirts",
      handle: "casual-outfit",
      supportedGenders: ['men', 'women'],

      genderTabs: {
        men:   { label: "Men",   tag: "Men"   },
        women: { label: "Women", tag: "Women" }
      },
      defaultGender: "men",

      genderHandles: {
        // men:   "men-casual-out-fit",
        women: "women-polos"
      },

      rowLabel: "BRAND",
      teamRowLabel: null,

      seasons: [
        { title: "Summer", tag: "Summer", emoji: "🌞" },
        { title: "Winter", tag: "Winter", emoji: "❄️" }
      ],

      typesBySeason: {
        "Summer": [
          { tag: "Casual Short Sleeve",             title: "Short Sleeve" },
          { tag: "Casual Polos Shirt Short Sleeve", title: "Polo Short Sleeve" },
          { tag: "Casual Short",                    title: "Shorts" },
          { tag: "Casual Summer Kamis",             title: "Summer Kamis" }
        ],
        "Winter": [
          { tag: "Casual Jacket",                   title: "Jacket" },
          { tag: "Casual Long Sleeve",              title: "LONG  SLEEVE" },
          { tag: "Casual Polos Shirt Long Sleeve",  title: "Polo Long Sleeve" },
          { tag: "Casual Puffer Jacket",            title: "Puffer Jacket" },
          { tag: "Casual Pijama",                   title: "Pyjama" },
          { tag: "Casual Winter Kamis",             title: "Winter Kamis" }
        ]
      },

      brands: [
        { title: "BOSS",           tag: "Boss",              logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/Hugo_Boss_idElAmacV6_0.svg?v=1788896453" },
        { title: "Tommy Hilfiger", tag: "Tommy Hilfiger",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/Tommy_Hilfiger_id_OGQAezT_1.png?v=1788896232" },
        { title: "Calvin Klein",   tag: "Calvin Klein",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/calvin.png?v=1788896111" },
        { title: "Ralph Lauren",   tag: "Polo Ralph Lauren", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/Ralph_Lauren-Logo-PNG6.png?v=1788896643" }
      ],

      casualMode: true
    },

    // ==================== FORMULA 1 ====================
    "f1": {
      title: "Formula 1",
      handle: "f1",
      supportedGenders: ['men', 'kids'],

      rowLabel: "BRAND",

      productTypes: [
        { tag: "T-Shirt",        title: "T-Shirt" },
        { tag: "Polo",           title: "Polo" },
        { tag: "Casual shirt",   title: "Casual" },
        { tag: "Bomber Jacket",  title: "Bomber" },
        { tag: "F1 caps",        title: "Cap" }
      ],

      labelClicks: {
        types: {
          pattern: "parent-plus-tag",
          buttonTextFormat: "See All {name}"
        }
      },

      leagues: {

        "f1": {
          title: "F1 Brands",
          logo: null,
          teams: {
            "f1-audi":            { title: "Audi",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/audi.png?v=1788473346" },
            "f1-bmw":             { title: "BMW",              logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/bmw.png?v=1788473318" },
            "f1-cadillac":        { title: "Cadillac",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/cadillac.png?v=1788473314" },
            "f1-ferrari":         { title: "Ferrari",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ferrari.png?v=1788473348" },
            "f1-ford":            { title: "Ford",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ford.png?v=1788473341" },
            "f1-harley-davidson": { title: "Harley-Davidson",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/harley.png?v=1788473342" },
            "f1-kawasaki":        { title: "Kawasaki",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/kawasaki.png?v=1788473327" },
            "f1-lamborghini":     { title: "Lamborghini",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lambergeni.png?v=1788473347" },
            "f1-lexus":           { title: "Lexus",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lexus.png?v=1788473341" },
            "f1-mclaren":         { title: "McLaren",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
            "f1-mercedes":        { title: "Mercedes",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/mercedes.png?v=1788473336" },
            "f1-porsche":         { title: "Porsche",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/porch.png?v=1788473346" },
            "f1-red-bull":        { title: "Red Bull",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/redbull.png?v=1788473340" }
          }
        }

      }
    },

    // ==================== CAPS ====================
    "caps": {
      title: "Caps",
      handle: "caps-1",
      supportedGenders: ['men', 'women', 'kids'],   // unisex — supports all   // parent /collections/caps-1 (smart collection: caps OR cpas OR F1 caps)

      // Caps are unisex — hide gender tabs entirely on Caps pages.
      hideGenderTabs: true,

      rowLabel: "BRAND",
      teamRowLabel: "BRAND",

      // Caps have no product-type sub-filters. Empty array explicitly overrides
      // the global productTypes list so the KIT row stays hidden even when a
      // brand (team) is selected.
      productTypes: [],

      leagues: {
        // Single synthetic league containing both cap brands as team pills.
        // The league key matches the parent handle so the "single synthetic league"
        // rendering logic engages (leagues row hidden, teams row shows brands directly).
        "caps-1": {
          title: "Cap Brands",
          logo: null,
          teams: {
            "caps":      { title: "Polo Caps",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/caps.jpg?v=1788893720" },
            "f1-caps-1": { title: "Formula 1 Caps", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/f1-caps.jpg?v=1788893446" }
          }
        }
      }
    }

  }

};
// oct-15-2026 starts

// // shirts-hierarchy.js
// // Shirts filter hierarchy — Categories → Leagues → Teams → Product Types
// //
// // CATEGORIES currently supported:
// //   1. Football Jerseys  — traditional league/team/type structure
// //   2. Gym Shirts        — Type + Brand + Season, Men|Women tabs
// //   3. Casual Shirts     — Brand + Season-conditional Types, Men|Women tabs
// //   4. Formula 1         — 15 brand-as-team collections, Kids tabs
// //   5. Caps              — 2 brand collections, unisex (no gender tabs)

// window.ShirtsHierarchy = {

//   // ============ GLOBAL PRODUCT TYPES ============
//   // Tag-based filters used on Football team pages.
//   // F1 overrides these with its own productTypes list.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "LONG SLEEVE",  title: "LONG SLEEVE" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ SUPPORTED GENDERS PER CATEGORY ============
//   // Used on gender landing pages (/collections/women, /men, /kids) to reorder
//   // the categories row so gender-relevant categories appear first.
//   // NOTE: this is separate from `genderTabs` (per-category gender switching);
//   // it's ONLY consulted on top-level landings.
//   //
//   // Add this key to any new category to signal which genders it supports.
//   // Categories WITHOUT this field are assumed to support ['men', 'kids'].

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     // ==================== FOOTBALL JERSEYS ====================
//     "football-jerseys": {
//       title: "Football Jerseys",
//       supportedGenders: ['men', 'kids'],

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           handle: ["international-kits", "national-team-jerseys-home-away"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil" },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France" },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany" },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal" }
//           }
//         }

//       }
//     },

//     // ==================== GYM SHIRTS ====================
//     "gym-shirts": {
//       title: "Gym Shirts",
//       handle: "sport-fit",
//       supportedGenders: ['men', 'women'],

//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       rowLabel: "TYPE",
//       teamRowLabel: "BRAND",

//       leagues: {
//         "jackets": { title: "Jackets & Coats",         logo: null, genderHandles: { men: "men-jackets", women: "women-jackets" } },
//         "hoodies": { title: "Hoodies & Sweatshirts",   logo: null, genderHandles: { men: "men-hoodies", women: "women-hoodies" } },
//         "tops":    { title: "Tops & T-Shirts",         logo: null, genderHandles: { men: "men-tops",    women: "women-tops"    } },
//         "pants":   { title: "Trousers & Leggings",     logo: null, genderHandles: { men: "men-pants",   women: "women-pants"   } },
//         "shorts":  { title: "Shorts",                  logo: null, genderHandles: { men: "men-shorts",  women: "women-shorts"  } },
//         "skirts":  { title: "Skirts & Skorts",         logo: null, genderHandles: { men: "men-skirts",  women: "women-skirts"  } },
//         "polos":   { title: "Polo Shirts",             logo: null, genderHandles: { men: "men-polos",   women: "women-polos"   } }
//       },

//       brands: [
//         { title: "Nike",   tag: "Nike",   logo: null },
//         { title: "Adidas", tag: "Adidas", logo: null }
//       ],

//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ],

//       labelClicks: {
//         teams: {
//           pattern: "brand-collection",
//           buttonTextFormat: "Shop {name}"
//         }
//       }
//     },

//     // ==================== CASUAL SHIRTS ====================
//     "casual-shirts": {
//       title: "Casual Shirts",
//       handle: "casual-outfit",
//       supportedGenders: ['men', 'women'],

//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       genderHandles: {
//         // men:   "men-casual-out-fit",
//         women: "women-polos"
//       },

//       rowLabel: "BRAND",
//       teamRowLabel: null,

//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ],

//       typesBySeason: {
//         "Summer": [
//           { tag: "Casual Short Sleeve",             title: "Short Sleeve" },
//           { tag: "Casual Polos Shirt Short Sleeve", title: "Polo Short Sleeve" },
//           { tag: "Casual Short",                    title: "Shorts" },
//           { tag: "Casual Summer Kamis",             title: "Summer Kamis" }
//         ],
//         "Winter": [
//           { tag: "Casual Jacket",                   title: "Jacket" },
//           { tag: "Casual Long Sleeve",              title: "LONG  SLEEVE" },
//           { tag: "Casual Polos Shirt Long Sleeve",  title: "Polo Long Sleeve" },
//           { tag: "Casual Puffer Jacket",            title: "Puffer Jacket" },
//           { tag: "Casual Pijama",                   title: "Pyjama" },
//           { tag: "Casual Winter Kamis",             title: "Winter Kamis" }
//         ]
//       },

//       brands: [
//         { title: "BOSS",           tag: "Boss",              logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/Hugo_Boss_idElAmacV6_0.svg?v=1788896453" },
//         { title: "Tommy Hilfiger", tag: "Tommy Hilfiger",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/Tommy_Hilfiger_id_OGQAezT_1.png?v=1788896232" },
//         { title: "Calvin Klein",   tag: "Calvin Klein",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/calvin.png?v=1788896111" },
//         { title: "Ralph Lauren",   tag: "Polo Ralph Lauren", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/Ralph_Lauren-Logo-PNG6.png?v=1788896643" }
//       ],

//       casualMode: true
//     },

//     // ==================== FORMULA 1 ====================
//     "f1": {
//       title: "Formula 1",
//       handle: "f1",
//       supportedGenders: ['men', 'kids'],

//       rowLabel: "BRAND",

//       productTypes: [
//         { tag: "T-Shirt",        title: "T-Shirt" },
//         { tag: "Polo",           title: "Polo" },
//         { tag: "Casual shirt",   title: "Casual" },
//         { tag: "Bomber Jacket",  title: "Bomber" },
//         { tag: "F1 caps",        title: "Cap" }
//       ],

//       labelClicks: {
//         types: {
//           pattern: "parent-plus-tag",
//           buttonTextFormat: "See All {name}"
//         }
//       },

//       leagues: {

//         "f1": {
//           title: "F1 Brands",
//           logo: null,
//           teams: {
//             "f1-audi":            { title: "Audi",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/audi.png?v=1788473346" },
//             "f1-bmw":             { title: "BMW",              logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/bmw.png?v=1788473318" },
//             "f1-cadillac":        { title: "Cadillac",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/cadillac.png?v=1788473314" },
//             "f1-ferrari":         { title: "Ferrari",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ferrari.png?v=1788473348" },
//             "f1-ford":            { title: "Ford",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ford.png?v=1788473341" },
//             "f1-harley-davidson": { title: "Harley-Davidson",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/harley.png?v=1788473342" },
//             "f1-kawasaki":        { title: "Kawasaki",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/kawasaki.png?v=1788473327" },
//             "f1-lamborghini":     { title: "Lamborghini",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lambergeni.png?v=1788473347" },
//             "f1-lexus":           { title: "Lexus",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lexus.png?v=1788473341" },
//             "f1-mclaren":         { title: "McLaren",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
//             "f1-mercedes":        { title: "Mercedes",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/mercedes.png?v=1788473336" },
//             "f1-porsche":         { title: "Porsche",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/porch.png?v=1788473346" },
//             "f1-red-bull":        { title: "Red Bull",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/redbull.png?v=1788473340" }
//           }
//         }

//       }
//     },

//     // ==================== CAPS ====================
//     "caps": {
//       title: "Caps",
//       handle: "caps-1",
//       supportedGenders: ['men', 'women', 'kids'],   // unisex — supports all   // parent /collections/caps-1 (smart collection: caps OR cpas OR F1 caps)

//       // Caps are unisex — hide gender tabs entirely on Caps pages.
//       hideGenderTabs: true,

//       rowLabel: "BRAND",
//       teamRowLabel: "BRAND",

//       // Caps have no product-type sub-filters. Empty array explicitly overrides
//       // the global productTypes list so the KIT row stays hidden even when a
//       // brand (team) is selected.
//       productTypes: [],

//       leagues: {
//         // Single synthetic league containing both cap brands as team pills.
//         // The league key matches the parent handle so the "single synthetic league"
//         // rendering logic engages (leagues row hidden, teams row shows brands directly).
//         "caps-1": {
//           title: "Cap Brands",
//           logo: null,
//           teams: {
//             "caps":      { title: "Polo Caps",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/caps.jpg?v=1788893720" },
//             "f1-caps-1": { title: "Formula 1 Caps", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/f1-caps.jpg?v=1788893446" }
//           }
//         }
//       }
//     }

//   }

// };

// oct-15-2026 ends

// // shirts-hierarchy.js
// // Shirts filter hierarchy — Categories → Leagues → Teams → Product Types
// //
// // CATEGORIES currently supported:
// //   1. Football Jerseys  — traditional league/team/type structure
// //   2. Gym Shirts        — Type + Brand + Season, Men|Women tabs
// //   3. Casual Shirts     — Brand + Season-conditional Types, Men|Women tabs
// //   4. Formula 1         — 15 brand-as-team collections, Kids tabs
// //   5. Caps              — 2 brand collections, unisex (no gender tabs)

// window.ShirtsHierarchy = {

//   // ============ GLOBAL PRODUCT TYPES ============
//   // Tag-based filters used on Football team pages.
//   // F1 overrides these with its own productTypes list.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "Long Sleeve",  title: "LONG SLEEVE" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     // ==================== FOOTBALL JERSEYS ====================
//     "football-jerseys": {
//       title: "Football Jerseys",

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           handle: ["international-kits", "national-team-jerseys-home-away"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil" },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France" },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany" },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal" }
//           }
//         }

//       }
//     },

//     // ==================== GYM SHIRTS ====================
//     "gym-shirts": {
//       title: "Gym Shirts",
//       handle: "sport-fit",

//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       rowLabel: "TYPE",
//       teamRowLabel: "BRAND",

//       leagues: {
//         "jackets": { title: "Jackets & Coats",         logo: null, genderHandles: { men: "men-jackets", women: "women-jackets" } },
//         "hoodies": { title: "Hoodies & Sweatshirts",   logo: null, genderHandles: { men: "men-hoodies", women: "women-hoodies" } },
//         "tops":    { title: "Tops & T-Shirts",         logo: null, genderHandles: { men: "men-tops",    women: "women-tops"    } },
//         "pants":   { title: "Trousers & Leggings",     logo: null, genderHandles: { men: "men-pants",   women: "women-pants"   } },
//         "shorts":  { title: "Shorts",                  logo: null, genderHandles: { men: "men-shorts",  women: "women-shorts"  } },
//         "skirts":  { title: "Skirts & Skorts",         logo: null, genderHandles: { men: "men-skirts",  women: "women-skirts"  } },
//         "polos":   { title: "Polo Shirts",             logo: null, genderHandles: { men: "men-polos",   women: "women-polos"   } }
//       },

//       brands: [
//         { title: "Nike",   tag: "Nike",   logo: null },
//         { title: "Adidas", tag: "Adidas", logo: null }
//       ],

//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ],

//       labelClicks: {
//         teams: {
//           pattern: "brand-collection",
//           buttonTextFormat: "Shop {name}"
//         }
//       }
//     },

//     // ==================== CASUAL SHIRTS ====================
//     "casual-shirts": {
//       title: "Casual Shirts",
//       handle: "casual-outfit",

//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       genderHandles: {
//         // men:   "men-casual-out-fit",
//         women: "women-casual-out-fit"
//       },

//       rowLabel: "BRAND",
//       teamRowLabel: null,

//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ],

//       typesBySeason: {
//         "Summer": [
//           { tag: "Casual Short Sleeve",             title: "Short Sleeve" },
//           { tag: "Casual Polos Shirt Short Sleeve", title: "Polo Short Sleeve" },
//           { tag: "Casual Short",                    title: "Shorts" },
//           { tag: "Casual Summer Kamis",             title: "Summer Kamis" }
//         ],
//         "Winter": [
//           { tag: "Casual Jacket",                   title: "Jacket" },
//           { tag: "Casual Long Sleeve",              title: "LONG  SLEEVE" },
//           { tag: "Casual Polos Shirt Long Sleeve",  title: "Polo Long Sleeve" },
//           { tag: "Casual Puffer Jacket",            title: "Puffer Jacket" },
//           { tag: "Casual Pijama",                   title: "Pyjama" },
//           { tag: "Casual Winter Kamis",             title: "Winter Kamis" }
//         ]
//       },

//       brands: [
//         { title: "BOSS",           tag: "Boss",              logo: null },
//         { title: "Tommy Hilfiger", tag: "Tommy Hilfiger",    logo: null },
//         { title: "Calvin Klein",   tag: "Calvin Klein",      logo: null },
//         { title: "Ralph Lauren",   tag: "Polo Ralph Lauren", logo: null }
//       ],

//       casualMode: true
//     },

//     // ==================== FORMULA 1 ====================
//     "f1": {
//       title: "Formula 1",
//       handle: "f1",

//       rowLabel: "BRAND",

//       productTypes: [
//         { tag: "T-Shirt",        title: "T-Shirt" },
//         { tag: "Polo",           title: "Polo" },
//         { tag: "Casual shirt",   title: "Casual" },
//         { tag: "Bomber Jacket",  title: "Bomber" },
//         { tag: "F1 caps",        title: "Cap" }
//       ],

//       labelClicks: {
//         types: {
//           pattern: "parent-plus-tag",
//           buttonTextFormat: "See All {name}"
//         }
//       },

//       leagues: {

//         "f1": {
//           title: "F1 Brands",
//           logo: null,
//           teams: {
//             "f1-audi":            { title: "Audi",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/audi.png?v=1788473346" },
//             "f1-bmw":             { title: "BMW",              logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/bmw.png?v=1788473318" },
//             "f1-cadillac":        { title: "Cadillac",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/cadillac.png?v=1788473314" },
//             "f1-ferrari":         { title: "Ferrari",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ferrari.png?v=1788473348" },
//             "f1-ford":            { title: "Ford",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ford.png?v=1788473341" },
//             "f1-harley-davidson": { title: "Harley-Davidson",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/harley.png?v=1788473342" },
//             "f1-kawasaki":        { title: "Kawasaki",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/kawasaki.png?v=1788473327" },
//             "f1-lamborghini":     { title: "Lamborghini",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lambergeni.png?v=1788473347" },
//             "f1-lexus":           { title: "Lexus",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lexus.png?v=1788473341" },
//             "f1-mclaren":         { title: "McLaren",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
//             "f1-mercedes":        { title: "Mercedes",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/mercedes.png?v=1788473336" },
//             "f1-porsche":         { title: "Porsche",          logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/porch.png?v=1788473346" },
//             "f1-red-bull":        { title: "Red Bull",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/redbull.png?v=1788473340" }
//           }
//         }

//       }
//     },

//     // ==================== CAPS ====================
//     "caps": {
//       title: "Caps",
//       handle: "caps-1",   // parent /collections/caps-1 (smart collection: caps OR cpas OR F1 caps)

//       // Caps are unisex — hide gender tabs entirely on Caps pages.
//       hideGenderTabs: true,

//       rowLabel: "BRAND",
//       teamRowLabel: "BRAND",

//       // Caps have no product-type sub-filters. Empty array explicitly overrides
//       // the global productTypes list so the KIT row stays hidden even when a
//       // brand (team) is selected.
//       productTypes: [],

//       leagues: {
//         // Single synthetic league containing both cap brands as team pills.
//         // The league key matches the parent handle so the "single synthetic league"
//         // rendering logic engages (leagues row hidden, teams row shows brands directly).
//         "caps-1": {
//           title: "Cap Brands",
//           logo: null,
//           teams: {
//             "caps":      { title: "Polo Caps",      logo: null },
//             "f1-caps-1": { title: "Formula 1 Caps", logo: null }
//           }
//         }
//       }
//     }

//   }

// };
// // shirts-hierarchy.js
// // Football Shirts filter — Category → League → Team → Product Type
// //
// // ARCHITECTURE:
// //   - Top-level CATEGORY (e.g., "Football Jerseys" or "Formula 1") is a catch-all collection.
// //   - Each category has LEAGUES. Each league has TEAMS. Each team supports
// //     tag-based PRODUCT TYPE filtering (Long Sleeve, Retro, etc.).
// //   - Gender is a TAG: Men = no filter, Kids = ?filter.p.tag=Kids
// // 
// // FORMULA 1:
// //   Uses the same shape as Football. F1 has ONE synthetic "league" containing
// //   all 15 F1 brands as teams (each with its own /collections/f1-{brand} collection).

// window.ShirtsHierarchy = {

//   // ============ GLOBAL PRODUCT TYPES ============
//   // Tag-based filters that apply on team pages (Football Jerseys teams).
//   // NOTE: F1 has its own productTypes list (see the f1 category below) that
//   // overrides this for F1 team pages.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "LONG SLEEVE",  title: "LONG SLEEVE" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     // ==================== FOOTBALL JERSEYS ====================
//     "football-jerseys": {
//       title: "Football Jerseys",

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           // Tag-based league: teams filter by country tag on the parent collection.
//           // Array form allows aliases (e.g., 'national-team-jerseys-home-away' also resolves here).
//           handle: ["international-kits", "national-team-jerseys-home-away"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil" },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France" },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany" },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal" }
//           }
//         }

//       }
//     },

//     // ==================== GYM SHIRTS ====================
//     "gym-shirts": {
//       title: "Gym Shirts",
//       handle: "sport-fit",   // parent collection = /collections/sport-fit (Training Edit, tag Sport Fit)

//       // Custom gender labels (Men|Women instead of Men|Kids Shirts)
//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       // Row labels for gym context
//       rowLabel: "TYPE",           // League row → "Type" (Jackets, Hoodies, Tops...)
//       teamRowLabel: "BRAND",      // Team row → "Brand" (Nike, Adidas) — repurposed for brand tags

//       // Product-category "leagues" — each maps to gender-specific collections.
//       // The engine picks the right collection based on active gender:
//       //   Men + Jackets → /collections/men-jackets
//       //   Women + Jackets → /collections/women-jackets
//       // Any of the gender-specific handles ALSO resolve back to this "league" entry.
//       leagues: {

//         "jackets": {
//           title: "Jackets & Coats",
//           logo: null,
//           genderHandles: { men: "men-jackets", women: "women-jackets" }
//         },

//         "hoodies": {
//           title: "Hoodies & Sweatshirts",
//           logo: null,
//           genderHandles: { men: "men-hoodies", women: "women-hoodies" }
//         },

//         "tops": {
//           title: "Tops & T-Shirts",
//           logo: null,
//           genderHandles: { men: "men-tops", women: "women-tops" }
//         },

//         "pants": {
//           title: "Trousers & Leggings",
//           logo: null,
//           genderHandles: { men: "men-pants", women: "women-pants" }
//         },

//         "shorts": {
//           title: "Shorts",
//           logo: null,
//           genderHandles: { men: "men-shorts", women: "women-shorts" }
//         },

//         "skirts": {
//           title: "Skirts & Skorts",
//           logo: null,
//           genderHandles: { men: "men-skirts", women: "women-skirts" }
//         },

//         "polos": {
//           title: "Polo Shirts",
//           logo: null,
//           genderHandles: { men: "men-polos", women: "women-polos" }
//         }

//       },

//       // Brands as TAG filters (like International Kits' countries)
//       // Rendered in the "teams" row when a category (league) is active.
//       brands: [
//         { title: "Nike",   tag: "Nike",   logo: null },
//         { title: "Adidas", tag: "Adidas", logo: null }
//       ],

//       // Seasons as TAG filters, rendered as a SEPARATE row below Brand.
//       // Can be combined with Type and Brand filters simultaneously.
//       // Example: /collections/men-jackets?filter.p.tag=Nike&filter.p.tag=Winter
//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ],

//       // Clickable row labels — "see all X" shortcuts.
//       // When an active filter is present in a row, the label becomes clickable
//       // and navigates to a related view.
//       //
//       // Format: labelClicks[rowLevel] = { pattern, buttonTextFormat, handleMap? }
//       //   pattern 'brand-collection': use active tag as lowercase-hyphenated collection handle
//       //     (e.g., Nike → /collections/nike, Adidas → /collections/adidas)
//       //   pattern 'handle-map': explicit tag → handle mapping via handleMap
//       //   pattern 'parent-plus-tag': navigate to category.handle + ?filter.p.tag=<active>
//       //   buttonTextFormat: template with {name} placeholder for the display label
//       //     (e.g., "Shop {name}" → "Shop Nike")
//       labelClicks: {
//         teams: {  // The "BRAND" row (Nike/Adidas)
//           pattern: "brand-collection",
//           buttonTextFormat: "Shop {name}"
//         }
//       }
//     },

//     // ==================== CASUAL SHIRTS ====================
//     "casual-shirts": {
//       title: "Casual Shirts",
//       handle: "casual-outfit",   // parent = /collections/casual-out-fit

//       // Same Men|Women gender pattern as Gym
//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       // Category-level gender-specific parents
//       // (When switching gender, navigate to the gender's version of the parent)
//       genderHandles: {
//         // men:   "men-casual-out-fit",
//         women: "women-casual-out-fit"
//       },

//       // For Casual, "leagues" row is repurposed as BRAND row (tag-based).
//       rowLabel: "BRAND",
//       teamRowLabel: null,   // no teams-level row

//       // Seasons — required to see Types (guided flow)
//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ],

//       // Season-conditional product types.
//       // The engine reads typesBySeason[activeSeason] to render the Type row.
//       // If no season is picked, the Type row is hidden (guided flow).
//       typesBySeason: {
//         "Summer": [
//           { tag: "Casual Short Sleeve",             title: "Short Sleeve" },
//           { tag: "Casual Polos Shirt Short Sleeve", title: "Polo Short Sleeve" },
//           { tag: "Casual Short",                    title: "Shorts" },
//           { tag: "Casual Summer Kamis",             title: "Summer Kamis" }
//         ],
//         "Winter": [
//           { tag: "Casual Jacket",                   title: "Jacket" },
//           { tag: "Casual Long Sleeve",              title: "LONG  SLEEVE" },
//           { tag: "Casual Polos Shirt Long Sleeve",  title: "Polo Long Sleeve" },
//           { tag: "Casual Puffer Jacket",            title: "Puffer Jacket" },
//           { tag: "Casual Pijama",                   title: "Pyjama" },
//           { tag: "Casual Winter Kamis",             title: "Winter Kamis" }
//         ]
//       },

//       // Brands as TAG filters (rendered in the "leagues" row for Casual).
//       brands: [
//         { title: "BOSS",           tag: "Boss",         logo: null },
//         { title: "Tommy Hilfiger", tag: "Tommy Hilfiger", logo: null },
//         { title: "Calvin Klein",   tag: "Calvin Klein",   logo: null },
//         { title: "Ralph Lauren",   tag: "Polo Ralph Lauren",   logo: null }
//       ],

//       // Flag to signal "casual mode" — engine uses brands as leagues row
//       casualMode: true
//     },

//     "f1": {
//       title: "Formula 1",
//       handle: "f1",   // parent collection = /collections/f1

//       // Per-category label overrides
//       // - League row label → "BRAND" (shown when league row is visible; F1 hides it)
//       // - Team row: F1's teams ARE the brands, so keep them visible and labeled "Brand"
//       rowLabel: "BRAND",

//       // F1-specific product types (per-category override of the global productTypes).
//       // These are TAG filters on the current F1 collection page.
//       // Tags below MUST match your live Shopify product tags exactly (case-sensitive).
//       productTypes: [
//         { tag: "T-Shirt",        title: "T-Shirt" },
//         { tag: "Polo",           title: "Polo" },
//         { tag: "Casual shirt",   title: "Casual" },
//         { tag: "Bomber Jacket",  title: "Bomber" },
//         { tag: "F1 caps",        title: "Cap" }
//       ],

//       // Clickable KIT label: when a type is active on any F1 brand page
//       // (e.g., f1-ferrari?filter.p.tag=Cap), clicking the KIT label jumps to
//       // /collections/f1?filter.p.tag=Cap — that type across all F1 brands.
//       labelClicks: {
//         types: {
//           pattern: "parent-plus-tag",
//           buttonTextFormat: "See All {name}"
//         }
//       },

//       leagues: {

//         // F1 has ONE synthetic "league" that contains all 15 brands as teams.
//         // The league key 'f1' matches the parent /collections/f1 URL,
//         // so visiting the F1 parent page shows all brands.
//         "f1": {
//           title: "F1 Brands",
//           logo: null,
//           // No `handle` field → the league key 'f1' IS the collection handle
//           teams: {
//            "f1-audi":            { title: "Audi",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/audi.png?v=1788473346" },
//   "f1-bmw":             { title: "BMW",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/bmw.png?v=1788473318" },
//   "f1-cadillac":        { title: "Cadillac",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/cadillac.png?v=1788473314" },
//   "f1-ferrari":         { title: "Ferrari",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ferrari.png?v=1788473348" },
//   "f1-ford":            { title: "Ford",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ford.png?v=1788473341" },
//   "f1-harley-davidson": { title: "Harley-Davidson",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/harley.png?v=1788473342" },
//   "f1-kawasaki":        { title: "Kawasaki",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/kawasaki.png?v=1788473327" },
//   "f1-lamborghini":     { title: "Lamborghini",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lambergeni.png?v=1788473347" },
//   "f1-lexus":           { title: "Lexus",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lexus.png?v=1788473341" },
//   "f1-mclaren":         { title: "McLaren",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
//   "f1-mercedes":        { title: "Mercedes",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/mercedes.png?v=1788473336" },
//   "f1-porsche":         { title: "Porsche",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/porch.png?v=1788473346" },
//   "f1-red-bull":        { title: "Red Bull",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/redbull.png?v=1788473340" }
//             // "f1-the-merch-lab":   { title: "The Merch Lab",  logo: null }
//           }
//         }

//       }
//     }

//   }

// };

// -------------------------------------------------------------------------------------
// // shirts-hierarchy.js
// // Football Shirts filter — Category → League → Team → Product Type
// //
// // ARCHITECTURE:
// //   - Top-level CATEGORY (e.g., "Football Jerseys" or "Formula 1") is a catch-all collection.
// //   - Each category has LEAGUES. Each league has TEAMS. Each team supports
// //     tag-based PRODUCT TYPE filtering (Long Sleeve, Retro, etc.).
// //   - Gender is a TAG: Men = no filter, Kids = ?filter.p.tag=Kids
// //
// // FORMULA 1:
// //   Uses the same shape as Football. F1 has ONE synthetic "league" containing
// //   all 15 F1 brands as teams (each with its own /collections/f1-{brand} collection).

// window.ShirtsHierarchy = {

//   // ============ GLOBAL PRODUCT TYPES ============
//   // Tag-based filters that apply on team pages (Football Jerseys teams).
//   // NOTE: F1 has its own productTypes list (see the f1 category below) that
//   // overrides this for F1 team pages.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "Long Sleeve",  title: "Long Sleeve" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     // ==================== FOOTBALL JERSEYS ====================
//     "football-jerseys": {
//       title: "Football Jerseys",

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           // Tag-based league: teams filter by country tag on the parent collection.
//           // Array form allows aliases (e.g., 'national-team-jerseys-home-away' also resolves here).
//           handle: ["international-kits", "national-team-jerseys-home-away"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil" },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France" },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany" },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal" }
//           }
//         }

//       }
//     },

//     // ==================== GYM SHIRTS ====================
//     "gym-shirts": {
//       title: "Gym Shirts",
//       handle: "sport-fit",   // parent collection = /collections/sport-fit (Training Edit, tag Sport Fit)

//       // Custom gender labels (Men|Women instead of Men|Kids Shirts)
//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       // Row labels for gym context
//       rowLabel: "TYPE",           // League row → "Type" (Jackets, Hoodies, Tops...)
//       teamRowLabel: "BRAND",      // Team row → "Brand" (Nike, Adidas) — repurposed for brand tags

//       // Product-category "leagues" — each maps to gender-specific collections.
//       // The engine picks the right collection based on active gender:
//       //   Men + Jackets → /collections/men-jackets
//       //   Women + Jackets → /collections/women-jackets
//       // Any of the gender-specific handles ALSO resolve back to this "league" entry.
//       leagues: {

//         "jackets": {
//           title: "Jackets & Coats",
//           logo: null,
//           genderHandles: { men: "men-jackets", women: "women-jackets" }
//         },

//         "hoodies": {
//           title: "Hoodies & Sweatshirts",
//           logo: null,
//           genderHandles: { men: "men-hoodies", women: "women-hoodies" }
//         },

//         "tops": {
//           title: "Tops & T-Shirts",
//           logo: null,
//           genderHandles: { men: "men-tops", women: "women-tops" }
//         },

//         "pants": {
//           title: "Trousers & Leggings",
//           logo: null,
//           genderHandles: { men: "men-pants", women: "women-pants" }
//         },

//         "shorts": {
//           title: "Shorts",
//           logo: null,
//           genderHandles: { men: "men-shorts", women: "women-shorts" }
//         },

//         "skirts": {
//           title: "Skirts & Skorts",
//           logo: null,
//           genderHandles: { men: "men-skirts", women: "women-skirts" } 
//         },

//         "polos": {
//           title: "Polo Shirts",
//           logo: null,
//           genderHandles: { men: "men-polos", women: "women-polos" }
//         }

//       },

//       // Brands as TAG filters (like International Kits' countries)
//       // Rendered in the "teams" row when a category (league) is active.
//       brands: [
//         { title: "Nike",   tag: "Nike",   logo: null },
//         { title: "Adidas", tag: "Adidas", logo: null }
//       ],

//       // Seasons as TAG filters, rendered as a SEPARATE row below Brand.
//       // Can be combined with Type and Brand filters simultaneously.
//       // Example: /collections/men-jackets?filter.p.tag=Nike&filter.p.tag=Winter
//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ]
//     },

//     // ==================== CASUAL SHIRTS ====================
//     "casual-shirts": {
//       title: "Casual Shirts",
//       handle: " casual-out-fit",   // parent = /collections/casual-out-fit

//       // Same Men|Women gender pattern as Gym
//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       // Category-level gender-specific parents
//       // (When switching gender, navigate to the gender's version of the parent)
//       genderHandles: {
//         men:   "men-casual-out-fit",
//         women: "women-casual-out-fit"
//       },

//       // For Casual, "leagues" row is repurposed as BRAND row (tag-based).
//       rowLabel: "BRAND",
//       teamRowLabel: null,   // no teams-level row

//       // Seasons — required to see Types (guided flow)
//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ],

//       // Season-conditional product types.
//       // The engine reads typesBySeason[activeSeason] to render the Type row.
//       // If no season is picked, the Type row is hidden (guided flow).
//       typesBySeason: {
//         "Summer": [
//           { tag: "Casual Short Sleeve",             title: "Short Sleeve" },
//           { tag: "Casual Polos Shirt Short Sleeve", title: "Polo Short Sleeve" },
//           { tag: "Casual Short",                    title: "Shorts" },
//           { tag: "Casual Summer Kamis",             title: "Summer Kamis" }
//         ],
//         "Winter": [
//           { tag: "Casual Jacket",                   title: "Jacket" },
//           { tag: "Casual Long Sleeve",              title: "Long Sleeve" },
//           { tag: "Casual Polos Shirt Long Sleeve",  title: "Polo Long Sleeve" },
//           { tag: "Casual Puffer Jacket",            title: "Puffer Jacket" },
//           { tag: "Casual Pijama",                   title: "Pyjama" },
//           { tag: "Casual Winter Kamis",             title: "Winter Kamis" }
//         ]
//       },

//       // Brands as TAG filters (rendered in the "leagues" row for Casual).
//       brands: [
//         { title: "BOSS",           tag: "BOSS",           logo: null },
//         { title: "Tommy Hilfiger", tag: "Tommy Hilfiger", logo: null },
//         { title: "Calvin Klein",   tag: "Calvin Klein",   logo: null },
//         { title: "Ralph Lauren",   tag: "Ralph Lauren",   logo: null }
//       ],

//       // Flag to signal "casual mode" — engine uses brands as leagues row
//       casualMode: true
//     },

//     "f1": {
//       title: "Formula 1",
//       handle: "f1",   // parent collection = /collections/f1

//       // Per-category label overrides
//       // - League row label → "BRAND" (shown when league row is visible; F1 hides it)
//       // - Team row: F1's teams ARE the brands, so keep them visible and labeled "Brand"
//       rowLabel: "BRAND",

//       // F1-specific product types (per-category override of the global productTypes).
//       // These are TAG filters on the current F1 collection page.
//       productTypes: [
//         { tag: "T-Shirt",        title: "T-Shirt" },
//         { tag: "Polo",           title: "Polo" },
//         { tag: "Casual shirt",   title: "Casual" },
//         { tag: "Bomber Jacket",  title: "Bomber" },
//         { tag: "F1 caps",            title: "Cap" }
//       ],

//       leagues: {

//         // F1 has ONE synthetic "league" that contains all 15 brands as teams.
//         // The league key 'f1' matches the parent /collections/f1 URL,
//         // so visiting the F1 parent page shows all brands.
//         "f1": {
//           title: "F1 Brands",
//           logo: null,
//           // No `handle` field → the league key 'f1' IS the collection handle
//           teams: {
//             "f1-aston-martin":    { title: "Aston Martin",   logo: null },
//             "f1-audi":            { title: "Audi",           logo: null },
//             "f1-bmw":             { title: "BMW",            logo: null },
//             "f1-cadillac":        { title: "Cadillac",       logo: null },
//             "f1-ferrari":         { title: "Ferrari",        logo: null },
//             "f1-ford":            { title: "Ford",           logo: null },
//             "f1-harley-davidson": { title: "Harley-Davidson", logo: null },
//             "f1-kawasaki":        { title: "Kawasaki",       logo: null },
//             "f1-lamborghini":     { title: "Lamborghini",    logo: null },
//             "f1-lexus":           { title: "Lexus",          logo: null },
//             "f1-mclaren":         { title: "McLaren",        logo: null },
//             "f1-mercedes":        { title: "Mercedes",       logo: null },
//             "f1-porsche":         { title: "Porsche",        logo: null },
//             "f1-red-bull":        { title: "Red Bull",       logo: null }
//             // "f1-the-merch-lab":   { title: "The Merch Lab",  logo: null }
//           }
//         }

//       }
//     }

//   }

// };

// -----------------------------------------------------------------------------------
// // shirts-hierarchy.js
// // Football Shirts filter — Category → League → Team → Product Type
// //
// // ARCHITECTURE:
// //   - Top-level CATEGORY (e.g., "Football Jerseys" or "Formula 1") is a catch-all collection.
// //   - Each category has LEAGUES. Each league has TEAMS. Each team supports
// //     tag-based PRODUCT TYPE filtering (Long Sleeve, Retro, etc.).
// //   - Gender is a TAG: Men = no filter, Kids = ?filter.p.tag=Kids
// //
// // FORMULA 1:
// //   Uses the same shape as Football. F1 has ONE synthetic "league" containing
// //   all 15 F1 brands as teams (each with its own /collections/f1-{brand} collection).

// window.ShirtsHierarchy = {

//   // ============ GLOBAL PRODUCT TYPES ============
//   // Tag-based filters that apply on team pages (Football Jerseys teams).
//   // NOTE: F1 has its own productTypes list (see the f1 category below) that
//   // overrides this for F1 team pages.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "Long Sleeve",  title: "Long Sleeve" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     // ==================== FOOTBALL JERSEYS ====================
//     "football-jerseys": {
//       title: "Football Jerseys",

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           // Tag-based league: teams filter by country tag on the parent collection.
//           // Array form allows aliases (e.g., 'national-team-jerseys-home-away' also resolves here).
//           handle: ["international-kits", "national-team-jerseys-home-away"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil" },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France" },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany" },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal" }
//           }
//         }

//       }
//     },

//     // ==================== GYM SHIRTS ====================
//     "gym-shirts": {
//       title: "Gym Shirts",
//       handle: "sport-fit",   // parent collection = /collections/sport-fit (Training Edit, tag Sport Fit)

//       // Custom gender labels (Men|Women instead of Men|Kids Shirts)
//       genderTabs: {
//         men:   { label: "Men",   tag: "Men"   },
//         women: { label: "Women", tag: "Women" }
//       },
//       defaultGender: "men",

//       // Row labels for gym context
//       rowLabel: "TYPE",           // League row → "Type" (Jackets, Hoodies, Tops...)
//       teamRowLabel: "BRAND",      // Team row → "Brand" (Nike, Adidas) — repurposed for brand tags

//       // Product-category "leagues" — each maps to gender-specific collections.
//       // The engine picks the right collection based on active gender:
//       //   Men + Jackets → /collections/men-jackets
//       //   Women + Jackets → /collections/women-jackets
//       // Any of the gender-specific handles ALSO resolve back to this "league" entry.
//       leagues: {

//         "jackets": {
//           title: "Jackets & Coats",
//           logo: null,
//           genderHandles: { men: "men-jackets", women: "women-jackets" }
//         },

//         "hoodies": {
//           title: "Hoodies & Sweatshirts",
//           logo: null,
//           genderHandles: { men: "men-hoodies", women: "women-hoodies" }
//         },

//         "tops": {
//           title: "Tops & T-Shirts",
//           logo: null,
//           genderHandles: { men: "men-tops", women: "women-tops" }
//         },

//         "pants": {
//           title: "Trousers & Leggings",
//           logo: null,
//           genderHandles: { men: "men-pants", women: "women-pants" }
//         },

//         "shorts": {
//           title: "Shorts",
//           logo: null,
//           genderHandles: { men: "men-shorts", women: "women-shorts" }
//         },

//         "skirts": {
//           title: "Skirts & Skorts",
//           logo: null,
//           genderHandles: { men: "men-skirts", women: "women-skirts" }
//         },

//         "polos": {
//           title: "Polo Shirts",
//           logo: null,
//           genderHandles: { men: "men-polos", women: "women-polos" }
//         }

//       },

//       // Brands as TAG filters (like International Kits' countries)
//       // Rendered in the "teams" row when a category (league) is active.
//       brands: [
//         { title: "Nike",   tag: "Nike",   logo: null },
//         { title: "Adidas", tag: "Adidas", logo: null }
//       ],

//       // Seasons as TAG filters, rendered as a SEPARATE row below Brand.
//       // Can be combined with Type and Brand filters simultaneously.
//       // Example: /collections/men-jackets?filter.p.tag=Nike&filter.p.tag=Winter
//       seasons: [
//         { title: "Summer", tag: "Summer", emoji: "🌞" },
//         { title: "Winter", tag: "Winter", emoji: "❄️" }
//       ]
//     },

//     "f1": {
//       title: "Formula 1",
//       handle: "f1",   // parent collection = /collections/f1

//       // Per-category label overrides
//       // - League row label → "BRAND" (shown when league row is visible; F1 hides it)
//       // - Team row: F1's teams ARE the brands, so keep them visible and labeled "Brand"
//       rowLabel: "BRAND",

//       // F1-specific product types (per-category override of the global productTypes).
//       // These are TAG filters on the current F1 collection page.
//       productTypes: [
//         { tag: "T-Shirt",        title: "T-Shirt" },
//         { tag: "Polo",           title: "Polo" },
//         { tag: "Casual Shirt",   title: "Casual" },
//         { tag: "Bomber Jacket",  title: "Bomber" },
//         { tag: "Cap",            title: "Cap" }
//       ],

//       leagues: {

//         // F1 has ONE synthetic "league" that contains all 15 brands as teams.
//         // The league key 'f1' matches the parent /collections/f1 URL,
//         // so visiting the F1 parent page shows all brands.
//         "f1": {
//           title: "F1 Brands",
//           logo: null,
//           // No `handle` field → the league key 'f1' IS the collection handle
//           teams: {
//            "f1-aston-martin":    { title: "Aston Martin",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
//   "f1-audi":            { title: "Audi",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/audi.png?v=1788473346" },
//   "f1-bmw":             { title: "BMW",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/bmw.png?v=1788473318" },
//   "f1-cadillac":        { title: "Cadillac",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/cadillac.png?v=1788473314" },
//   "f1-ferrari":         { title: "Ferrari",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ferrari.png?v=1788473348" },
//   "f1-ford":            { title: "Ford",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ford.png?v=1788473341" },
//   "f1-harley-davidson": { title: "Harley-Davidson",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/harley.png?v=1788473342" },
//   "f1-kawasaki":        { title: "Kawasaki",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/kawasaki.png?v=1788473327" },
//   "f1-lamborghini":     { title: "Lamborghini",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lambergeni.png?v=1788473347" },
//   "f1-lexus":           { title: "Lexus",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lexus.png?v=1788473341" },
//   "f1-mclaren":         { title: "McLaren",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
//   "f1-mercedes":        { title: "Mercedes",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/mercedes.png?v=1788473336" },
//   "f1-porsche":         { title: "Porsche",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/porch.png?v=1788473346" },
//   "f1-red-bull":        { title: "Red Bull",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/redbull.png?v=1788473340" }
//   // "f1-the-merch-lab":   { title: "The Merch Lab",   logo: null }
//           }
//         }

//       }
//     }

//   }

// };

// ---------------------------------------------------------------------------------------------------------
// // shirts-hierarchy.js
// // Football Shirts filter — Category → League → Team → Product Type
// //
// // ARCHITECTURE:
// //   - Top-level CATEGORY (e.g., "Football Jerseys" or "Formula 1") is a catch-all collection.
// //   - Each category has LEAGUES. Each league has TEAMS. Each team supports
// //     tag-based PRODUCT TYPE filtering (Long Sleeve, Retro, etc.).
// //   - Gender is a TAG: Men = no filter, Kids = ?filter.p.tag=Kids
// //
// // FORMULA 1:
// //   Uses the same shape as Football. F1 has ONE synthetic "league" containing
// //   all 15 F1 brands as teams (each with its own /collections/f1-{brand} collection).

// window.ShirtsHierarchy = {

//   // ============ GLOBAL PRODUCT TYPES ============
//   // Tag-based filters that apply on team pages (Football Jerseys teams).
//   // NOTE: F1 has its own productTypes list (see the f1 category below) that
//   // overrides this for F1 team pages.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "Long Sleeve",  title: "Long Sleeve" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     // ==================== FOOTBALL JERSEYS ====================
//     "football-jerseys": {
//       title: "Football Jerseys",

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           // Tag-based league: teams filter by country tag on the parent collection.
//           // Array form allows aliases (e.g., 'national-team-jerseys-home-away' also resolves here).
//           handle: ["international-kits", "national-team-jerseys-home-away"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil" },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France" },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany" },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal" }
//           }
//         }

//       }
//     },

//     // ==================== FORMULA 1 ====================
//     "f1": {
//       title: "Formula 1",
//       handle: "f1",   // parent collection = /collections/f1

//       // Per-category label overrides
//       // - League row label → "BRAND" (shown when league row is visible; F1 hides it)
//       // - Team row: F1's teams ARE the brands, so keep them visible and labeled "Brand"
//       rowLabel: "BRAND",

//       // F1-specific product types (per-category override of the global productTypes).
//       // These are TAG filters on the current F1 collection page.
//       productTypes: [
//         { tag: "T-Shirt",        title: "T-Shirt" },
//         { tag: "Polo",           title: "Polo" },
//         { tag: "Casual Shirt",   title: "Casual" },
//         { tag: "Bomber Jacket",  title: "Bomber" },
//         { tag: "Cap",            title: "Cap" }
//       ],

//       leagues: {

//         // F1 has ONE synthetic "league" that contains all 15 brands as teams.
//         // The league key 'f1' matches the parent /collections/f1 URL,
//         // so visiting the F1 parent page shows all brands.
//         "f1": {
//           title: "F1 Brands",
//           logo: null,
//           // No `handle` field → the league key 'f1' IS the collection handle
//           teams: {
//   "f1-aston-martin":    { title: "Aston Martin",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
//   "f1-audi":            { title: "Audi",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/audi.png?v=1788473346" },
//   "f1-bmw":             { title: "BMW",             logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/bmw.png?v=1788473318" },
//   "f1-cadillac":        { title: "Cadillac",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/cadillac.png?v=1788473314" },
//   "f1-ferrari":         { title: "Ferrari",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ferrari.png?v=1788473348" },
//   "f1-ford":            { title: "Ford",            logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/ford.png?v=1788473341" },
//   "f1-harley-davidson": { title: "Harley-Davidson",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/harley.png?v=1788473342" },
//   "f1-kawasaki":        { title: "Kawasaki",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/kawasaki.png?v=1788473327" },
//   "f1-lamborghini":     { title: "Lamborghini",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lambergeni.png?v=1788473347" },
//   "f1-lexus":           { title: "Lexus",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/lexus.png?v=1788473341" },
//   "f1-mclaren":         { title: "McLaren",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/aston-martin.png?v=1788473320" },
//   "f1-mercedes":        { title: "Mercedes",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/mercedes.png?v=1788473336" },
//   "f1-porsche":         { title: "Porsche",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/porch.png?v=1788473346" },
//   "f1-red-bull":        { title: "Red Bull",        logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/redbull.png?v=1788473340" },
//   "f1-the-merch-lab":   { title: "The Merch Lab",   logo: null }

//           }
//         }

//       }
//     }

//   }

// };


// ---------------------------------------------------------------------------------------------------------







// // shirts-hierarchy.js
// // Football Shirts filter — Category → League → Team → Product Type
// //
// // ARCHITECTURE:
// //   - Top-level CATEGORY (e.g., "Football Jerseys") is a catch-all collection.
// //     Click it to see ALL products in that category across leagues/teams.
// //   - Each category has LEAGUES. Each league has TEAMS. Each team supports
// //     tag-based PRODUCT TYPE filtering (Long Sleeve, Retro, Kids, etc.).
// //   - Gender is a TAG: Men = no filter, Kids = ?filter.p.tag=Kids
// //
// // TO CUSTOMIZE:
// //   - Fix team handles below to match your actual Shopify collection handles
// //   - Fix league handles to match yours
// //   - Fix product type TAG values (Title Case) to match your product tags
// //   - Add team logo URLs when uploaded to Shopify Files

// window.ShirtsHierarchy = {

//   // ============ PRODUCT TYPES (applied on team collections) ============
//   // All product tags are Title Case (per your standardization decision).
//   // Titles are SHORT labels for compact display; tags match your product tags exactly.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "Long Sleeve",  title: "Long Sleeve" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     "football-jerseys": {
//       title: "Football Jerseys",
//       // (Casual Shirts, Gym Shirts would become siblings here later)

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309" },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           // NOTE: International Kits uses a SINGLE collection (international-kits)
//           // with country TAGS on products, rather than separate country collections.
//           // The `handle` here is the parent collection; each team's `tag` filters it.
//           // Array form allows multiple collection aliases to resolve to this same league.
//           handle: ["international-kits"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil"    },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France"    },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany"   },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal"  }
//           }
//         }

//       }
//     },

//     "f1": {
//       title: "Formula 1",
//       handle: "f1",   // parent collection = /collections/f1

//       // For F1, the "leagues" level is actually PRODUCT TYPE sub-collections
//       // (T-Shirts, Casual Shirts, Bomber Jackets). The engine treats them
//       // structurally the same as leagues; only the UI label differs.
//       // rowLabel controls the row heading shown on the frontend
//       // ("TYPE" instead of "LEAGUE" for F1).
//       rowLabel: "TYPE",

//       leagues: {

//         "f1-t-shirts": {
//           title: "T-Shirts",
//           logo: null
//           // No teams — this sub-category is a direct product listing
//         },

//         "f1-casual-shirts": {
//           title: "Casual Shirts",
//           logo: null
//         },

//         "f1-bomber-jacket": {
//           title: "Bomber Jackets",
//           logo: null
//         }

//       }
//     }

//   }

// };
// Lastet version end  

// // shirts-hierarchy.js
// // Football Shirts filter — Category → League → Team → Product Type
// //
// // ARCHITECTURE:
// //   - Top-level CATEGORY (e.g., "Football Jerseys") is a catch-all collection.
// //     Click it to see ALL products in that category across leagues/teams.
// //   - Each category has LEAGUES. Each league has TEAMS. Each team supports
// //     tag-based PRODUCT TYPE filtering (Long Sleeve, Retro, Kids, etc.).
// //   - Gender is a TAG: Men = no filter, Kids = ?filter.p.tag=Kids
// //
// // TO CUSTOMIZE:
// //   - Fix team handles below to match your actual Shopify collection handles
// //   - Fix league handles to match yours
// //   - Fix product type TAG values (Title Case) to match your product tags
// //   - Add team logo URLs when uploaded to Shopify Files

// window.ShirtsHierarchy = {

//   // ============ PRODUCT TYPES (applied on team collections) ============
//   // All product tags are Title Case (per your standardization decision).
//   // Titles are SHORT labels for compact display; tags match your product tags exactly.
//   productTypes: [
//     { tag: "Home",         title: "Home" },
//     { tag: "Away",         title: "Away" },
//     { tag: "Retro",        title: "Retro" },
//     { tag: "Long Sleeve",  title: "Long Sleeve" },
//     { tag: "Short Sleeve", title: "Short Sleeve" },
//     { tag: "Shorts",       title: "Shorts" },
//     { tag: "Track Suit",   title: "Track Suit" },
//     { tag: "Jacket",       title: "Jacket" },
//     { tag: "Scarf",        title: "Scarf" },
//     { tag: "Ball",         title: "Ball" }
//   ],

//   // ============ CATEGORIES (top-level) ============
//   categories: {

//     "football-jerseys": {
//       title: "Football Jerseys",
//       // (Casual Shirts, Gym Shirts would become siblings here later)

//       leagues: {

//         "premier-league": {
//           title: "Premier League",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_english-premier-league.football-logos.cc.svg?v=1787932655",
//           teams: {
//             "arsenal":            { title: "Arsenal",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_arsenal.football-logos.cc.svg?v=1787610148" },
//             "chelsea":            { title: "Chelsea",           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_chelsea.football-logos.cc.svg?v=1787694100" },
//             "manchester-city":    { title: "Manchester City",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-city.football-logos.cc.svg?v=1787694158" },
//             "manchester-united":  { title: "Manchester United", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_manchester-united.football-logos.cc.svg?v=1787694188" },
//             "liverpool":          { title: "Liverpool",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_liverpool.football-logos.cc.svg?v=1787694246" },
//             "newcastle":          { title: "Newcastle",         logo:"https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_newcastle.football-logos.cc.svg?v=1787694309"  },
//             "crystal-palace":     { title: "Crystal Palace",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/england_crystal-palace.football-logos.cc.svg?v=1787694352" }
//           }
//         },

//         "la-liga": {
//           title: "La Liga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_la-liga.football-logos.cc.svg?v=1787932681",
//           teams: {
//             "real-madrid":     { title: "Real Madrid",     logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_real-madrid.football-logos.cc.svg?v=1787694387" },
//             "fc-barcelona":    { title: "FC Barcelona",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_barcelona.football-logos.cc.svg?v=1787694390" },
//             "atletico-madrid": { title: "Atletico Madrid", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" }
//           }
//         },

//         "serie-a": {
//           title: "Serie A",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_serie-a.football-logos.cc.svg?v=1787932698",
//           teams: {
//             "ac-milan":    { title: "AC Milan",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/spain_atletico-madrid.football-logos.cc.svg?v=1787694405" },
//             "inter-milan": { title: "Inter Milan", logo: "" },
//             "juventus":    { title: "Juventus",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_juventus.football-logos.cc.svg?v=1787694786" },
//             "napoli":      { title: "Napoli",      logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/italy_napoli.football-logos.cc.svg?v=1787694834" }
//           }
//         },

//         "bundesliga": {
//           title: "Bundesliga",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bundesliga.football-logos.cc.svg?v=1787932708",
//           teams: {
//             "fc-bayern":         { title: "FC Bayern",         logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_bayern-munchen.football-logos.cc.svg?v=1787694902" },
//             "borussia-dortmund": { title: "Borussia Dortmund", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_borussia-dortmund.football-logos.cc.svg?v=1787694950" }
//           }
//         },

//         "international-kits": {
//           title: "International Kits",
//           logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/football-jerseys.png?v=1787932634",
//           // NOTE: International Kits uses a SINGLE collection (international-kits)
//           // with country TAGS on products, rather than separate country collections.
//           // The `handle` here is the parent collection; each team's `tag` filters it.
//           handle: ["international-kits", "national-team-jerseys-home-away"],
//           teams: {
//             "argentina": { title: "Argentina", logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/argentina_argentina-national-team.football-logos.cc.svg?v=1787695100", tag: "Argentina" },
//             "brazil":    { title: "Brazil",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brazil_brazil-national-team.football-logos.cc.svg?v=1787695100", tag: "Brazil"    },
//             "france":    { title: "France",    logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/france_france-national-team.football-logos.cc.svg?v=1787695100", tag: "France"    },
//             "germany":   { title: "Germany",   logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/germany_germany-national-team.football-logos.cc.svg?v=1787695100", tag: "Germany"   },
//             "portugal":  { title: "Portugal",  logo: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/portugal_primeira-liga.football-logos.cc.svg?v=1787695100", tag: "Portugal"  }
//           }
//         }

//       }
//     }

//   }

// };
